import { useCallback } from 'react';

import {
  GENERATION_TOOLS_INCLUDING_SUB_TEMPLATES_IN_GROUP,
  type GenerationTool,
  type GenerationToolGroup,
} from 'src/data/generationTool';
import type { SubTemplate } from 'src/data/template';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { TemplatesStore } from 'src/store/templates';

const useTemplatesState = createStateSelectorHook(TemplatesStore, ['subTemplates']);

type PrepareSubTemplatesFunction = (
  toolGroup: GenerationToolGroup,
  generationTool: GenerationTool
) => Array<Record<string, unknown>> | null;

/**
 * Checks if needed to render sub-templates within the group, and prepare the templates need to be there
 */
export const usePrepareToolSubTemplatesInGenerationGroup = (): PrepareSubTemplatesFunction => {
  const { subTemplates } = useTemplatesState();

  return useCallback(
    (toolGroup: GenerationToolGroup, generationTool: GenerationTool) => {
      const group = GENERATION_TOOLS_INCLUDING_SUB_TEMPLATES_IN_GROUP[toolGroup];
      if (!group || !group.includes(generationTool)) {
        return null;
      }

      return subTemplates
        ?.filter((subTemplate: SubTemplate) => subTemplate.generationTool === generationTool)
        .map((subTemplate: SubTemplate) => ({
          id: subTemplate.id,
          name: subTemplate.name,
          description: subTemplate.description,
          tool: subTemplate.generationTool,
        }));
    },
    [subTemplates]
  );
};
